import { track } from "./index.js";
/**
 * @internal
 */
export async function trackPayEvent(args) {
    return track({
        client: args.client,
        ecosystem: args.ecosystem,
        data: {
            source: "pay",
            action: args.event,
            clientId: args.client.clientId,
            chainId: args.chainId,
            walletAddress: args.walletAddress,
            walletType: args.walletType,
            tokenAddress: args.fromToken,
            amountWei: args.fromAmount,
            dstTokenAddress: args.toToken,
            dstChainId: args.chainId,
        },
    });
}
//# sourceMappingURL=pay.js.map